<div class="news">
  <h4 class="news__title main-title" [routerLink]="['/news', newsDate.id]">{{newsDate.title}}</h4>
  <p class="news__short">{{newsDate.content}}</p>
  <span class="news__date">{{newsDate.date}}</span>
  <div class="news__actions">
    <button class="button" [routerLink]="['/news', newsDate.id]">{{'CORE.NEWS.button' | translate}}<i class="icon-angle-right"></i></button>
  </div>
</div>
